export default "__VITE_ASSET__1af1a66f__"